export enum UseExtraBalancesTypes {
    BALANCE_UTILITY = 'utility',
    BALANCE_GYMNET = 'gymnet',
}
